import { Chip, Grid, TextField, MenuItem, FormControlLabel, Checkbox, Select } from "@material-ui/core";
import React, { useReducer } from "react";
import styled from "styled-components";
import _ from "lodash";
import { SecondaryButton, ButtonText, ImageLoader } from "@loanbossinc/component-library";

const Label = styled.span`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  color: #5f6368;
  margin-top: 10px;
`;

const AppCard = ({ app, companyTypes, companyLevels, disabled, onActivate, onDeactivate, onSetLogo, history }) => {
  /*
   * NOTE:  I am so sorry for hackishly forcing an update.  If there is a better way, please tell me.  I suspect there is.
   *        https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
   *        -- Jonathan Byrne 02/01/2022
   */
  const [_ignored, forceUpdate] = useReducer(x => x + 1, 0);

  return (
    <Grid container spacing={8} style={{ marginTop: "30px" }}>
      <Grid item md={5}>
        <div style={{ marginTop: "0 !important", display: "flex", height: "135px", fontFamily: "Work Sans" }}>
          <div>
            <ImageLoader
              src={app.logoImageUri}
              defaultImage=""
              height="105px"
              width="105px"
              enableChangeDialog={!disabled}
              disableRemoveButton
              changeButtonText="Change logo"
              changeDialogTitle="Change logo"
              acceptedFileExtensions={[".svg"]}
              onImageChange={file => {
                onSetLogo(file);
                /*
                 * NOTE:  I hate doing this but I don't think there is a better way.  The URL for the image never changes, even when the
                 *        image itself is updated.  This means that it will not reload the new image after it is uploaded to the API.  I
                 *        suspect there is a way to do it with JavaScript, but that would be even uglier.  Considering that this is only
                 *        a page for a subset of system admins, I am not worried about the decreased UX. - Jonathan Byrne 02/07/2022
                 */
                history.go(0);
              }}
            />
          </div>
          <div>
            <div style={{ fontWeight: "500", fontSize: "20px", marginBottom: "6px", paddingTop: "8px" }}>{app.name}</div>
            <div style={{ fontWeight: "400", fontSize: "13px", marginBottom: "10px", lineHeight: "16px" }}>{app.description}</div>
            {app.isPremiumApp &&
              <>
                <SecondaryButton size="sm-fluid" label="Contact Sales" />
                {!app.isActive &&
                  <ButtonText
                    size="sm-fluid"
                    label="Activate"
                    onClick={() => {
                      onActivate();
                    }}
                  />}
                {app.isActive &&
                  <ButtonText size="sm-fluid" label="Dectivate" onClick={() => onDeactivate()} />}
              </>}
            {!app.isPremiumApp && <SecondaryButton size="sm-fluid" label="Get" />}
          </div>
        </div>
        <div style={{ marginBottom: "60px", paddingLeft: "23px", display: "flex", justifyContent: "start", alignItems: "flex-start", flexDirection: "column" }}>
          <FormControlLabel
            disabled={disabled}
            className="manageCheckbox"
            control={
              <Checkbox
                checked={app.isPremiumApp}
                onChange={() => {
                  app.isPremiumApp = !app.isPremiumApp;
                  forceUpdate();
                }}
                value="requireAdminToActivate"
                color="primary"
              />
            }
            label="Requires System Admin to Activate"
          />
          <FormControlLabel
            disabled={disabled}
            className="manageCheckbox"
            control={
              <Checkbox
                checked={app.isVisibleInStore}
                onChange={() => {
                  app.isVisibleInStore = !app.isVisibleInStore;
                  forceUpdate();
                }}
                value="adminActive"
                color="primary"
              />
            }
            label="Visible to Users/Company Admins"
          />
        </div>
      </Grid>
      <Grid item md={5} style={{ display: "flex", flexDirection: "column" }}>
        <Label>App Description</Label>
        <TextField
          disabled={disabled}
          className="textManage"
          multiline
          id="filled-name"
          value={app.description}
          onChange={event => {
            app.description = event.target.value;
            forceUpdate();
          }}
          margin="normal"
          variant="filled"
        />
        <Label>Company Type</Label>
        <Select
          disabled={disabled}
          multiple
          value={app.companyTypes.map(selectedCompanyType => selectedCompanyType.companyTypeId)}
          onChange={event => {
            app.companyTypes = event.target.value.map(displayCompanyTypeId => ({
              appId: app.id,
              companyTypeId: displayCompanyTypeId
            }));
            forceUpdate();
          }}
          renderValue={selectedCompanyTypeIds => (
            <div>
              {selectedCompanyTypeIds.map(selectedCompanyTypeId => {
                const selectedCompanyType = companyTypes.find(companyType => companyType.id === selectedCompanyTypeId);

                return <Chip key={selectedCompanyType.id} label={selectedCompanyType.name} />;
              })}
            </div>
          )}
        >
          {companyTypes.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        <Label>Subscription Level</Label>
        <Select
          disabled={disabled}
          multiple
          value={app.companyLevels.map(selectedCompanyLevel => selectedCompanyLevel.companyLevelId)}
          onChange={event => {
            app.companyLevels = event.target.value.map(displayCompanyLevelId => ({
              appId: app.id,
              companyLevelId: displayCompanyLevelId
            }));
            forceUpdate();
          }}
          renderValue={selectedCompanyLevelIds => (
            <div>
              {selectedCompanyLevelIds.map(selectedCompanyLevelId => {
                const selectedCompanyLevel = companyLevels.find(companyLevel => companyLevel.id === selectedCompanyLevelId);

                return <Chip key={selectedCompanyLevel.id} label={selectedCompanyLevel.label} />;
              })}
            </div>
          )}
        >
          {companyLevels.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );
};

export default AppCard;
